// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2MmfS","rootSmall":"AddTileButton_rootSmall__2D7uM"};